export const DocumentTypes = [
  { label: 'Face Sheet', value: 'Face Sheet' },
  { label: "Physician's Order", value: "Physician's Order" },
  { label: 'Clinical Documentation', value: 'Clinical Documentation' },
  {
    label: 'Other (as applicable for skilled care)',
    value: 'Other (as applicable for skilled care)',
  },
];
export const DocumentTypes_UF = [
{	label:'Clinical Documentation',	value:	'Clinical Documentation'},
{	label:'Face Sheet',	value: 'Face Sheet'}	,
{	label:'History & Physical',	value:'History & Physical'}	,
{	label:'Medication List'		,	value:'Medication List'	}	,
{	label:"Physician's Order"	,	value:"Physician's Order"	}	,
{	label:'NOMNC'		,	value: 'NOMNC'}	,
{	label:'DENC'	,	value:'DENC'}	,
{	label:'AOR'		,	value:'AOR'}	,
{	label:'Other'		,	value:'Other'}	,
{	label:'Member Appeal'		,	value:'Member Appeal'	}	,
{	label:'Provider Appeal'		,	value: 'Provider Appeal'},
{ label: 'Level Adjustment', value: 'Level Adjustment'}
];

export const DocumentTypesSuggestedChanges = [{ label: 'Level Adjustment', value: 'Level Adjustment'}];
export const NomncRescind = [{ label: 'NOMNC Rescind', value: 'NOMNC Rescind'}];

